import React from "react";
import Dashboard from "../Pages/Dashboard";

const AdminRoute = () => {
  return (
    <div>
      <Dashboard />
    </div>
  );
};

export default AdminRoute;
